import YaCounter from "../analytics/ym";
import {stateCatalogElement} from "./_function";
import GoogleAnalytics from "../analytics/ga";

window.VegasCatalog.Fav = {
	getParams: function ($product, appendParams = {}) {
		let selectors = $product.find('.form-selector').serializeArray();
		let params = mergeTwoJsonObj(
			[
				{name: 'id', value: $product.data('id')},
				{name: '_token', value: App.csrf},
			],
			selectors
		);

		for (let name in appendParams) {
			params.push({name: name, value: appendParams[name]});
		}

		return params;
	},

	add: function (lparams, callback) {
		lparams = lparams || {};

		if (Array.isArray(lparams)) {
			lparams.push({name: '_token', value: App.csrf});
		} else {
			lparams._token = App.csrf;
		}

		this.addRequest(lparams, function (data) {
			if (!data.error) {
				VegasCatalog.popup(' Товар добавлен в избранное');
				VegasCatalog.Compare.totals(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	del: function (lparams, callback) {
		lparams = lparams || {};

		if (Array.isArray(lparams)) {
			lparams.push({name: '_token', value: App.csrf});
		} else {
			lparams._token = App.csrf;
		}

		this.delRequest(lparams, function (data) {
			if (!data.error) {
				VegasCatalog.popup(' Товар убран из избранного');
				VegasCatalog.Compare.totals(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/fav/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);

			new YaCounter().goal('add-to-fav');
			new GoogleAnalytics().goal('Add-to-fav');
		});
	},

	delRequest: function (params, callback) {
		$.post('/fav/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	totals: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-fav][data-counter="products"]').attr('data-cnt', data.products_count);
		}
	},
};

$(document).ready(function () {
	const stateAdditionalFav = {
		prd: {
			class: 'in-fav'
		},
		btn: {
			classes: {
				add: 'btn-light',
				del: 'btn-dark'
			},
			title: {
				isTitleText: false,
				isTooltipText: true,
				text: {
					add: 'В избранном',
					del: 'Убрать из избранного'
				}
			}
		}
	};

	/** ADD **/
	$(document).on('click', '[data-product] [data-fav][data-action=add]', function () {
		let $product = $(this).closest('[data-product]');
		let $btn = $(this);

		VegasCatalog.Fav.add(VegasCatalog.Fav.getParams($product), function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalFav)
		});

		return false;
	});
	$(document).on('click', '[data-product-modal] [data-fav][data-action=add]', function () {
		let $product = $(this).closest('[data-product-modal]');
		let $btn = $(this);

		VegasCatalog.Fav.add(VegasCatalog.Fav.getParams($product), function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalFav)
		});

		return false;
	});

	$(document).on('click', '[data-product-item] [data-fav][data-action=add]', function () {
		let $product = $(this).closest('[data-product-item]'),
			$btn = $(this);

		VegasCatalog.Fav.add(VegasCatalog.Fav.getParams($product), function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalFav);
		});

		return false;
	});

	$(document).on('click', '[data-product-cart-item] [data-fav][data-action=add]', function () {
		let $product = $(this).closest('[data-product-cart-item]'),
			$btn = $(this);

		VegasCatalog.Fav.add(VegasCatalog.Fav.getParams($product, {
			pivot_id: $product.data('pivot_id')
		}), function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalFav);
		});

		return false;
	});

	/**  REMOVE **/
	$(document).on('click', '[data-product] [data-fav][data-action=del]', function () {
		let $product = $(this).closest('[data-product]');
		let $btn = $(this);

		VegasCatalog.Fav.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalFav)
		});

		return false;
	});
	$(document).on('click', '[data-product-modal] [data-fav][data-action=del]', function () {
		let $product = $(this).closest('[data-product-modal]');
		let $btn = $(this);

		VegasCatalog.Fav.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalFav)
		});

		return false;
	});

	$(document).on('click', '[data-product-item] [data-fav][data-action=del]', function () {
		let $product = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let params = {id: $product.data('id')};

		if ($product.data('pivot_id')) {
			params = {pivot_id: $product.data('pivot_id')};
		}

		VegasCatalog.Fav.del(params, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalFav);
		});

		return false;
	});

	$(document).on('click', '[data-product-cart-item] [data-fav][data-action=del]', function () {
		let $product = $(this).closest('[data-product-cart-item]');
		let $btn = $(this);

		VegasCatalog.Fav.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalFav);
		});

		return false;
	});
});
